import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-assets-claim-qr-code',
  templateUrl: './assets-claim-qr-code.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AssetsClaimQrCodeComponent {
  paper_id = '';

  constructor(private dialogRef: MatDialogRef<AssetsClaimQrCodeComponent>) {}

  /**
   * Close the dialog with the trimmed printed short hash so the caller can claim it.
   *
   * @return {void}
   */
  onClaim(): void {
    const value = (this.paper_id || '').trim();
    if (!value) {
      return;
    }
    this.dialogRef.close(value);
  }
}
